import { render } from "./PlaceOrder.vue?vue&type=template&id=2f3a6d83&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"

import "./PlaceOrder.vue?vue&type=style&index=0&id=2f3a6d83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3a6d83"]])

export default __exports__